import React from 'react';
import { AdminDashboard } from './dashboards/AdminDashboard';
import { GuideDashboard } from './dashboards/GuideDashboard';
import { OrganizerDashboard } from './dashboards/OrganizerDashboard';

export const Dashboard = () => {
  const userRole = localStorage.getItem('userRole');

  switch (userRole) {
    case 'admin':
      return <AdminDashboard />;
    case 'guide':
      return <GuideDashboard />;
    case 'organizer':
      return <OrganizerDashboard />;
    default:
      return null;
  }
};